import type { UserSession } from '../../shared/models';
import {
  normalizeCompanyMembershipRole,
  normalizeCompanyRoleFromClaim,
} from '../../features/company-context/utils/company-membership-role.util';
import { readCompanyRoleRawFromAccessToken } from './jwt-access-token-claims.util';
import {
  parseTaskeoUserRoleValue123,
  pickFirstCompanyRoleValueFromRecords,
} from './taskeo-company-role-response.util';

/**
 * Menu «dados da empresa» / preferências: **só Admin (2)** — não Owner (1) nem Member (3).
 * Sessão, JWT (se sessão Member estiver errada), `user.role` em texto; Owner na sessão não acede.
 */
export function isStrictCompanyAdminWorkspaceAccess(
  user: UserSession | null,
  accessToken: string | null
): boolean {
  if (!user) return false;

  const rec = user as unknown as Record<string, unknown>;
  const sessionValue = parseTaskeoUserRoleValue123(
    pickFirstCompanyRoleValueFromRecords([rec]) ?? user.roleValue
  );

  const jwtSaysAdmin = (): boolean => {
    const t = accessToken?.trim();
    if (!t) return false;
    const jwtRaw = readCompanyRoleRawFromAccessToken(t);
    const jwtValue = parseTaskeoUserRoleValue123(jwtRaw);
    if (jwtValue === 2) return true;
    if (jwtValue === 1 || jwtValue === 3) return false;
    return normalizeCompanyRoleFromClaim(jwtRaw, 'Member') === 'Admin';
  };

  if (sessionValue === 1) return false;
  if (sessionValue === 2) return true;
  if (sessionValue === 3) return jwtSaysAdmin();

  if (jwtSaysAdmin()) return true;
  return normalizeCompanyMembershipRole(user.role, 'Member') === 'Admin';
}
